// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// Shared scripts (API + client)
import { activityTypes } from '@fontan/shared';

// Local scripts
import { getStoredRecordings } from '../scripts/backupRecordings.js';



// ----------------------------------------------------------------------------
//   Setup
// ----------------------------------------------------------------------------


const SERVER_URL = process.env.REACT_APP_SERVER_URL;



// ----------------------------------------------------------------------------
//   API Calls
// ----------------------------------------------------------------------------


export const fetchCompletedVideos = async () => {
    try {
        const resp = await fetch(`${SERVER_URL}/completed-videos`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.status === 200) {
            const data = await resp.json();
            // return an array of video IDs
            return data.map((activity) => activity.video_id);
        } 
    } catch(err) {
        throw new Error('Error fetching videos:', err);
    }
}

export const createActivity = async (activityType, videoName = null, metadata = null) => {

    // Non-blocking IndexedDB lookup: attach a summary of all locally stored
    // recordings to the metadata. Blobs are stripped (not JSON-serializable).
    // Uses a fixed key `_localRecordings` to avoid collisions with caller-supplied
    // metadata fields. Any failure is caught and recorded in-place rather than
    // propagating.
    const localRecordingsResult = await getStoredRecordings()
        .then((recordings) => ({
            recordings: recordings.map(({ blob: _blob, ...rest }) => rest),
        }))
        .catch((err) => ({
            error: err?.message ?? String(err),
        }));

    // Add internal field(s) to metadata
    const enrichedMetadata = {
        ...metadata,
        _localRecordings: localRecordingsResult,
    };

    try {
        const res = await fetch(`${SERVER_URL}/activity/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ activityType, videoName, metadata: enrichedMetadata }),
        })
        return res.json();
    } catch(err) {
        throw new Error('Error creating activity:', err);
    }
}

export const fetchStudentActivities = async (userID) => {
    try {
        const resp = await fetch(`${SERVER_URL}/student/${userID}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.ok) {
            return resp.json();
        } else {
            throw new Error(`Error fetching student activities: ${resp.status}`);

        }
    } catch(err) {
        throw err;
    }
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------


export default {
    activityTypes,
    fetchCompletedVideos,
    createActivity,
    fetchStudentActivities,
};
